<script setup lang="ts">
const { count } = useCart();
const { count: wishlistCount } = useWishlist();
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);

const miniCartModal = useMiniCartModal();

import { useSearchStore } from "@/stores/search";

// Initialize the store
const searchStore = useSearchStore();

const openSearchMenu = () => {
  searchStore.isSearchSectionOpen = true;
};

const closeSearchMenu = () => {
  searchStore.isSearchSectionOpen = false;
};
</script>

<template>
  <div
    class="action-buttons flex items-center text-lg gap-4 ml-0 sm:ml-4 md:ml-10"
    role="navigation"
    :aria-label="$t('header.ariaLabelUserActionText')">

    <button
      class="action-button h-[20px] w-[20px] flex items-center justify-center search-button lg:hidden hover:text-primary focus:text-primary transition-color ease-in-out"
      :aria-label="$t('header.ariaLabelSearch')"
      id="toggleSearch">
      <i @click="openSearchMenu" class="icon-search-outline transition-all duration-300 ease-in-out" aria-hidden="true"></i>
      <i @click="closeSearchMenu" class="icon-close-outline hidden transition-all duration-300 ease-in-out" aria-hidden="true"></i>
    </button>

    <ClientOnly>
      <AccountMenu />
      <template #fallback>
        <div class="animate-pulse bg-gray-200 w-5 h-5 rounded-full"></div>
      </template>
    </ClientOnly>

    <NuxtLink
      class="action-button h-[20px] w-[20px] flex items-center justify-center relative heart-button hover:text-primary focus:text-primary transition-colors duration-300 ease-in-out"
      :aria-label="$t('header.ariaLabelWishlist')"
      data-testid="wishlist-button"
      :to="formatLink(`/wishlist`)"
    >
      <i class="icon-heart-outline" aria-hidden="true"></i>
      <ClientOnly>
        <span
          v-if="wishlistCount"
          class="count absolute -top-2 -right-2 leading-none text-xxs font-light text-white bg-primary rounded-full w-[18px] h-[18px] flex items-center justify-center"
        >
          {{ wishlistCount }}
        </span>
      </ClientOnly>
    </NuxtLink>

    <button
      class="action-button h-[20px] w-[20px] flex items-center justify-center relative bag-button hover:text-primary focus:text-primary transition-colors duration-300 ease-in-out"
      :aria-label="`${$t('header.ariaLabelMiniCart')} ${count > 0 ? count : ''}`"
      data-testid="cart-button"
      @click="miniCartModal.open"
    >
      <i class="icon-bag-outline" aria-hidden="true"></i>
      <span
        v-if="count > 0"
        class="count absolute -top-2 -right-2 leading-none text-xxs font-light text-white bg-primary rounded-full w-[18px] h-[18px] flex items-center justify-center"
      >
        {{ count || "" }}
      </span>
    </button>
    <CheckoutSideCart :controller="miniCartModal" />
  </div>
</template>